import dayjs, { unix } from 'dayjs'
import { IcsEvent } from 'ts-ics'

import { getScheduleTimestamps } from '@/entities/schedule'

/**
 * Ближайшие старты события в окне (now, until].
 * Без recurrence — DTSTART; с recurrence — разворот через getScheduleTimestamps.
 */
export const getUpcomingScheduleStarts = (
  event: IcsEvent,
  nowUnix: number,
  untilUnix: number,
): number[] => {
  if (!event.start?.date) {
    return []
  }

  if (!event.recurrenceRule) {
    const startUnix = dayjs(event.start.date).unix()
    return startUnix > nowUnix && startUnix <= untilUnix ? [startUnix] : []
  }

  const from = unix(nowUnix).startOf('day').unix()
  return getScheduleTimestamps(event, from, untilUnix)
    .filter((ts) => ts > nowUnix && ts <= untilUnix)
}
